import { Moment } from 'moment'
import React, { MouseEvent, useCallback, useMemo } from 'react'

import { useAppSelector } from '../../App/Hooks/reduxHooks'
import { IWorkingHours } from '../../App/store/features/person/interface/IWorkingHours'
import { IAbsence } from '../../App/store/features/person/interface/IWorkingSchedule'
import { Person } from '../../App/store/features/person/IPerson'
import { calendarSettingsSelector } from '../store/calendarSlice'

import {
  Timeslot,
  ColumnGridWrapper,
  TimeSlotShowTime,
  TimeSlotWrapper,
} from './style'
import { calcAbsenceTimeSlots } from './utils/calcAbsenceTimeSlots'
import { calcWorkingTimeSlots } from './utils/calcWorkingTimeSlots'
import { getSchemaWeekForDateAndPerson } from './utils/getSchemaWeekForDateAndPerson'

interface IProps {
  person: Person
  timeDivision: number
  date: Moment
  workingHours: IWorkingHours[]
  absences: IAbsence[]
  onEmptySlotClicked: (person: Person, clickedMoment: Moment) => void
}

export const ColumnGrid = ({
  timeDivision,
  person,
  date,
  workingHours,
  absences,
  onEmptySlotClicked,
}: IProps) => {
  console.log('Column GRID, has to many reRenders.')

  const calendarSettings = useAppSelector(calendarSettingsSelector)
  const colorContrast = calendarSettings.colorContrast
  const zoomLevelValue = calendarSettings.zoomLevelValue

  const slotClick = useCallback(
    (e: MouseEvent<HTMLDivElement>, hour: number, minute: number) => {
      e.preventDefault()
      const clickedMoment: Moment = date.set({
        hour,
        minute,
      })

      console.log(clickedMoment)
      if (e.type === 'click') {
        onEmptySlotClicked(person, clickedMoment)
      }
    },
    [date, onEmptySlotClicked, person],
  )

  const timeSlots = useMemo(() => {
    const schemaWeek: number = getSchemaWeekForDateAndPerson(date, person)

    const absenceTimeSlots = calcAbsenceTimeSlots(
      absences,
      person.id,
      date,
      timeDivision,
    )

    const workingTimeSlots = calcWorkingTimeSlots(
      workingHours,
      person.id,
      schemaWeek,
      timeDivision,
      date,
    )

    const newTimeSlots = []

    for (let i = 0; i < 24; i += 1) {
      for (let j = 0; j < 60; j += timeDivision) {
        const timeInMinutes: number = i * 60 + j
        const timeSlotKey = `timeslot${timeInMinutes}`
        const timeDisplay = `${i < 10 ? 0 : ''}${i}:${j}${j === 0 ? 0 : ''}`
        newTimeSlots.push(
          <TimeSlotWrapper key={`${i}_${j}`}>
            <Timeslot
              isAbsence={absenceTimeSlots.includes(timeInMinutes)}
              isWorking={workingTimeSlots.includes(timeInMinutes)}
              colorContrast={colorContrast}
              key={timeSlotKey}
              zoomLevelValue={zoomLevelValue}
              onClick={e => slotClick(e, i, j)}
            />
            <TimeSlotShowTime>{timeDisplay}</TimeSlotShowTime>
          </TimeSlotWrapper>,
        )
      }
    }

    return newTimeSlots
  }, [
    date,
    person,
    absences,
    timeDivision,
    workingHours,
    colorContrast,
    zoomLevelValue,
    slotClick,
  ])

  return <ColumnGridWrapper>{timeSlots}</ColumnGridWrapper>
}
